
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, Grid, IconButton, Box, Autocomplete } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getOrderingCategories } from '../../../../redux/slices/orderSheet';
import Iconify from '../../../../reusable-components/iconify';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';

NewPurchaseDialog.propTypes = {
  openPurchaseDialog: PropTypes.bool,
  handleClosePurchaseDialog: PropTypes.func,
}
export default function NewPurchaseDialog({openPurchaseDialog, handleClosePurchaseDialog}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: { facilities, categories, selectedFacilityId } } = useSelector((state) => state.orderSheet);
  const [value, setValue] = useState();

  const handleCategoryClick = (categoryId, name) => {
    handleClosePurchaseDialog();
    navigate(`/dashboard/orders/new-order/${value?.value}?categoryId=${categoryId}&category=${encodeURIComponent(name)}`);
  };

  useEffect(() => {
    setValue(facilities.find((option) => option.value === selectedFacilityId) || null);
  }, [facilities, selectedFacilityId]);

  return (
    <Dialog
      open={openPurchaseDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClosePurchaseDialog();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          color: 'primary',
        }}
      >
        New Purchase
        <CloseIconButton onClick={handleClosePurchaseDialog}/>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ fontWeight: 'bold' }}>Select a facility</DialogContentText>{' '}
        <Autocomplete
          sx={{
            width: '100%',
            mt: 1,
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiFormLabelRoot': 'none',
          }}
          type="new-password"
          options={facilities}
          autoHighlight
          getOptionLabel={(option) => option?.label}
          isOptionEqualToValue={(option, value) => option.label === value.label}
          value={value}
          onChange={(event, newValue) => {
            if (!newValue) return;
            setValue(newValue);
            dispatch(getOrderingCategories(newValue?.value));
          }}
          renderOption={(props, option) => (
            <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
              {option.label}
            </Box>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              label=""
              variant="outlined"
              inputProps={{
                ...params.inputProps,
              }}
            />
          )}
        />
        <DialogContentText sx={{ fontWeight: 'bold', mt: 3 }}>Select a category</DialogContentText>
        <Grid container spacing={1} sx={{ mb: 2 }}>
          {categories?.map((category) => (
            <Grid
              item
              xs={3}
              key={category.id}
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={1}
              onClick={() => handleCategoryClick(category.id, category.name)}
              sx={{ cursor: 'pointer', height: '100%' }}
            >
              <Grid item>
                <IconButton color="primary">
                  <Iconify icon={category.icon} width={40} height={40} />
                </IconButton>
              </Grid>
              <Grid item sx={{ textAlign: 'center'}}>
                {/* force category name to wrap to new line after a `/` by adding a space after the `/` */}
                {category.name.split("/").join("/ ")}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
}